import styled from "styled-components";
import {SiteLink as RouterLink} from "nav/SiteLink";

/**
 * Externalized styles for the active-storage refusal strip (ui#1664). The strip itself wears
 * {@link ./UpgradeHints.styles.NudgeRoot}'s gold treatment — this IS a "you have hit a paid-plan
 * limit" surface, which is exactly the signal gold carries in this app (unlike
 * {@link ./OverLimitNotice.styles.OverLimitRoot}, which deliberately avoids it) — so only the
 * /transfers exit and the held pass's line need primitives of their own.
 */
export const ManageTransfersLink = styled(RouterLink)`
	color: ${({theme}) => theme.tokens.ink};
	font-weight: 600;
	text-decoration: underline;
	text-underline-offset: 2px;

	&:hover {
		color: ${({theme}) => theme.tokens.ink2};
	}

	&:focus-visible {
		outline: 2px solid ${({theme}) => theme.tokens.focusOutline};
		outline-offset: 2px;
		border-radius: 4px;
	}
`;

/**
 * The held pass's line (kitecorp/transferify-ui#3046), on a line of its own under the refusal. The refusal ends on
 * the "delete an old transfer" link, which carries no punctuation of its own, so a sentence continued after it read
 * as one run-on sentence.
 */
export const PassLine = styled.span`
	display: block;
	margin-top: 4px;
`;
